// extracted by mini-css-extract-plugin
module.exports = {"list":"ShopList_list__DLD_Z","title":"ShopList_title__Oe_qh","wrapper":"ShopList_wrapper__XwM4i"};